<h2 mat-dialog-title>
    <mat-icon class="icon-20">merge_type</mat-icon> Merge Wells
</h2>

<section *ngIf="loading">
    <h2>Loading...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
    </mat-progress-bar>
</section>

<mat-card *ngIf="!loading">
    <div>
        <p color="primary">
            <strong>Note:</strong> This feature will merge all the Well Samples and Vouchers into the selected Well
            below <strong>AND DELETE</strong> the Wells not selected below.
        </p>
        Select the <strong>larger Well ID number</strong> when merging Wells
        <br /><br />
        <label>Select the Well to keep below: <br /></label>
        <small><i>This Well will absorb all sample and voucher data from the remaining Wells not selected.</i></small>
        <br />
        <br />
        <!-- Wells -->
        <form>
            <table mat-table [dataSource]="data" class="mat-elevation-z8" style="overflow-x: auto;"
                aria-describedby="mergeWells">
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef scope="col"> </th>
                    <td mat-cell *matCellDef="let element"> <input type="radio" id="wellId" name="wellId"
                            value="{{element.wellId}}" (click)="onChangeSelectedWell(element.wellId)" /></td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef scope="col"> OHA Well Id </th>
                    <td mat-cell *matCellDef="let element"> {{element.wellId}} </td>
                </ng-container>

                <ng-container matColumnDef="wellTag">
                    <th mat-header-cell *matHeaderCellDef scope="col"> Well Tag </th>
                    <td mat-cell *matCellDef="let element"> {{element.wellTag}} </td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef scope="col">Address</th>
                    <td mat-cell *matCellDef="let element">{{element.wellAddress1}}</td>
                </ng-container>

                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef scope="col">City </th>
                    <td mat-cell *matCellDef="let element">{{element.wellCity}} </td>
                </ng-container>

                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef scope="col">State</th>
                    <td mat-cell *matCellDef="let element">{{element.wellState}}</td>
                </ng-container>

                <ng-container matColumnDef="zip">
                    <th mat-header-cell *matHeaderCellDef scope="col">Zip</th>
                    <td mat-cell *matCellDef="let element">{{element.wellZip}}</td>
                </ng-container>

                <ng-container matColumnDef="county">
                    <th mat-header-cell *matHeaderCellDef scope="col">County</th>
                    <td mat-cell *matCellDef="let element">{{element.wellCounty}}</td>
                </ng-container>

                <ng-container matColumnDef="samples">
                    <th mat-header-cell *matHeaderCellDef scope="col"># of Samples</th>
                    <td mat-cell *matCellDef="let element">{{element.numberOfSamples}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </form>
    </div>
    <!-- Buttons -->
    <div>
        <br />
        <section *ngIf="merging">
            <h2>Merging...</h2>
            <mat-progress-bar mode="indeterminate" color="warn" aria-label="Merging...">
            </mat-progress-bar>
        </section>
        <button mat-button [disabled]="loading || merging || selectedWellId <= 0" mat-raised-button color="primary"
            (click)="merge()">Merge Wells</button>
        &nbsp;
        <button mat-button mat-raised-button mat-dialog-close="Cancel" aria-label="Cancel"
            [disabled]='merging'>Cancel</button>
    </div>
</mat-card>